module.exports = __webpack_public_path__ + "static/7-f95b8c2f0df229b544992574e993309f.png";